// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'
//引用公共方法
import utils from '@/util/util.js'
import mixin from './mixin/mixin'
import vueWaves from '@/util/waves.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/util/dialogTop'
Vue.use(vueWaves)
Vue.prototype.mixin = mixin;
Vue.prototype.utils=utils;
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js